import type { ShopBannerProps } from '../components/ShopBanner';

// Use the correct asset paths for static serving
const boilerImg = '/static/shop/fix-boiler.png';
const solarImg = '/static/shop/install-solar.png';
const acImg = '/static/shop/install-ac.png';

export const productCategories = [
  'boiler',
  'solar',
  'air-conditioning',
] as const;

export type ShopProductKey = (typeof productCategories)[number];

export const shopProducts: Record<
  ShopProductKey,
  Omit<ShopBannerProps, 'productName'>
> = {
  boiler: {
    headline: 'Get Your Boiler & Fitting Sorted',
    discountAmount: 150,
    featureText: 'Next-day install',
    bulletPoints: ['Top brands', 'Warranty included'],
    ctaLabel: 'Get your quote',
    ctaUrl: 'https://shop.checkatrade.com/boilers',
    productImg: boilerImg,
    productImgAlt: 'Boiler',
  },
  solar: {
    headline: 'Get an instant quote for your Solar Panels',
    discountAmount: 600,
    featureText: 'Top brands',
    bulletPoints: ['Instant price', 'Warranty included'],
    ctaLabel: 'Get your quote',
    ctaUrl: 'https://shop.checkatrade.com/solar-panels',
    productImg: solarImg,
    productImgAlt: 'Solar Panels',
  },
  'air-conditioning': {
    headline: 'Get Your AC Fitted Fast—All-Inclusive Quote',
    discountAmount: 100,
    featureText: 'Top brands',
    bulletPoints: ['Quick Installs', 'Warranty included'],
    ctaLabel: 'Get your quote',
    ctaUrl: 'https://shop.checkatrade.com/air-conditioners',
    productImg: acImg,
    productImgAlt: 'Air Conditioning',
  },
};
